<mat-toolbar role="contentinfo">
  <div class="spacer"></div>
  <div class="copyright">
    <span>{{ "FOOTER.COPYRIGHT_LONG" | translate }} {{ getYear() }}</span>
  </div>
</mat-toolbar>
